module.exports = __webpack_public_path__ + "static/media/radiobutton_checked.5cdc9078.svg";